import { useQuery } from '@tanstack/react-query';
import { getPermissions } from '@services/rbac.service';

export const PERMISSIONS_QUERY_KEY = ['rbac', 'permissions'];

export const usePermissions = () => useQuery({ queryKey: PERMISSIONS_QUERY_KEY, queryFn: getPermissions });
